import { verifyMessageHash, verifyMessageSignatures, verifyTimestamp } from '../utils/verification';
import {
  getValidateursIfMessageAValider,
  validateMessageAValiderForSync,
} from '../utils/validatorsAccept';
import type { MessageBase, MsgSignature } from '../types/message';

/**
 * Validate a decrypted message (hash, timestamp, signatures).
 * MessageAValider: accept only if signed by validators per validateurs;
 * otherwise crypto-only check when signatures present.
 */
export async function validateDecryptedMessage(
  decrypted: unknown,
  fetchSignatures: (hash: string) => Promise<MsgSignature[]>,
): Promise<boolean> {
  try {
    const msg = decrypted as MessageBase;
    if (msg.hash === undefined) {
      return false;
    }
    if (!(await verifyMessageHash(msg)) || !verifyTimestamp(msg.timestamp)) {
      return false;
    }
    const signatures = await fetchSignatures(msg.hash.hash_value);
    const sigList = signatures.map((s) => s.signature);
    const validateurs = getValidateursIfMessageAValider(msg);
    if (validateurs !== null) {
      return validateMessageAValiderForSync(
        msg,
        sigList,
        validateurs,
        '[SyncValidate]',
      );
    }
    if (sigList.length > 0) {
      const { valid } = verifyMessageSignatures(msg, sigList);
      return valid.length > 0;
    }
    return true;
  } catch {
    return false;
  }
}
